import { useContext, useCallback } from "react";
import NodeContext from "../../context/NodeContext";
import EdsSearchableSelect from "../EdsSearchableSelect";
import { NODE_TYPE } from "../../utils/constants";
import { InputContainer } from "./SkipToQuestionDropDown.styled";


const QUESTION_NODE_TYPES = [
  NODE_TYPE.COLLECT_INPUT_NODE,
  NODE_TYPE.BUTTONS_NODE,
  NODE_TYPE.FILE_UPLOAD_NODE,
  NODE_TYPE.CALENDAR_NODE,
  NODE_TYPE.MESSAGE_NODE,
];

function SkipToQuestionDropdown() {
  const { selectedNodeInfo, updateNode, nodes, isEditable } =
    useContext(NodeContext);

  const createOptions = useCallback(() => {
    if (!nodes || !selectedNodeInfo) return [];
    return nodes
      .filter(
        (node) =>
          QUESTION_NODE_TYPES.includes(node.type) &&
          node.id !== selectedNodeInfo.id
      )
      .map((node) => ({
        value: node.id,
        label: node.data?.titleText || node.type,
      }));
  }, [nodes, selectedNodeInfo]);

  const options = createOptions();

  if (options.length === 0) {
    return null;
  }

  const isDisabled = !isEditable || !selectedNodeInfo?.data?.isSkippable;

  return (
    <InputContainer>
      <EdsSearchableSelect
        options={options}
        value={selectedNodeInfo?.data?.skipToNodeId || ""}
        onChange={(value) => {
          updateNode(selectedNodeInfo.id, {
            ...selectedNodeInfo?.data,
            skipToNodeId: value || "",
          });
        }}
        isClearable={!!selectedNodeInfo?.data?.skipToNodeId && !isDisabled}
        isDisabled={isDisabled}
        placeholder="Select question to skip to"
        key={selectedNodeInfo?.id}
      />
    </InputContainer>
  );
}

export default SkipToQuestionDropdown;
